import React, { useEffect } from 'react';
import T from 'prop-types';
import { connect } from 'react-redux';
// components
import LinkUnavailable from 'components/LinkUnavailable';
// utils
import { sendNotify } from 'utils/airbrakeHelper';

// Unknown routes show a message instead of silently landing on the home page
const NotFound = ({ location, currentUser }) => {
  useEffect(() => {
    sendNotify({
      error: new Error('Unknown route'),
      route: location.pathname + location.search,
    }, currentUser);
  }, [location.pathname, location.search]);

  return <LinkUnavailable />;
};

NotFound.propTypes = {
  location: T.object.isRequired,
  currentUser: T.object,
};

export default connect(
  (state) => ({
    currentUser: state.auth.user,
  })
)(NotFound);
